import { TFunction } from 'i18next';
import { plurals } from 'utils/localization';

/**
 * Validuje fulltextové vyhledávání - pokud je zadáno jedno slovo, musí mít minimálně 4 znaky
 * @param value - hodnota k validaci
 * @param t - translation funkce
 * @returns chybová hláška nebo undefined
 */
export const validateSearchQuery = (
    value: string,
    t: TFunction
): string | undefined => {
    if (!value || value.trim() === '') {
        return undefined;
    }

    const trimmedValue = value.trim();
    const words = trimmedValue.split(/\s+/);

    // Pokud je to jedno slovo a má méně než 4 znaky
    if (words.length === 1 && trimmedValue.length < 4) {
        return plurals(t, 'general.minSearchLength', 4);
    }

    return undefined;
};
